import { UI_PAYMENTS_SET_LOADING } from "../../../uis/payments";

const setLoading = payload => dispatch =>
  dispatch({
    type: UI_PAYMENTS_SET_LOADING,
    payload
  });

export default setLoading;
